
import { defineComponent, ref, computed } from 'vue';

export default defineComponent({
  name: 'DiscursiveBanner',
  props: {
    label: {
      type: String,
      default: '',
    },
    modelValue: {
      type: [Array, String],
      require: true,
    },
    fn: {
      type: Function,
      require: false,
    },
  },
  setup(props) {
    const truncate = ref(true);
    const arr = computed(() => {
      if (typeof props.modelValue === 'string') return [props.modelValue];
      return props.modelValue;
    });

    return {
      arr,
      truncate,
    };
  },
});
